import React, { useEffect, useState } from 'react';
import ProductServices from '../../services/API/ProductServices';
import SellerProductCard from '../Shared/Cards/SellerProductCard';
import LoadingComponents from '../Shared/LoadingComponents';
import NoDataFound from '../Shared/NoDataFound';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';

const ProductCard = ({ setSubmitted, setProductId }) => {
  const [activeProducts, setActiveProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [show, setShow] = useState(false);

  const activeProductData = async () => {
    try {
      const res = await ProductServices.sellerActiveProducts();
      setActiveProducts(res.data);
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      toast.error(error?.response?.data?.message)
    }
  };

  const deleteSellerProduct = async (id) => {
    setIsLoading(true)
    setShow(false)
    ProductServices.deleteSellerProduct(id).then((res) => {
      setActiveProducts(res.data);
      activeProductData();
    }).catch((error) => {
      setIsLoading(false)
      toast.error(error?.response?.data?.message)
    })
  }
  useEffect(() => {
    activeProductData();
  }, []);

  return (
    <>
      <section id='productcard' style={{ padding: "15px 0px" }}>
        <div className='container'>
          <div className='row'>
            {isLoading ? (
              <LoadingComponents />
            ) : (
              <>
                {activeProducts?.length === 0 ? (
                  <NoDataFound title={'No data Products'} />
                ) : (
                  <>
                    {activeProducts.map((product) => (
                      <div className='col-lg-3 col' key={product?.guid}>
                        <SellerProductCard
                          data={product}
                          setSubmitted={setSubmitted}
                          setProductId={setProductId}
                          setSelectedProductId={setSelectedProductId}
                          setShow={setShow} />
                      </div>
                    ))}
                  </>
                )}
              </>
            )}

          </div>
        </div>
      </section>
      <Modal
        show={show}
        className='create-coupon-modal'
      >
        <div className='c-c-body'>
          <div className="coupon-title">Product Deletion</div>
          <div className="coupon-desc">Deleting this product will remove it permanently from your inventory. Are you sure you want to proceed?</div>
          <div className="p-d-button">
            <button className='p-d-c' onClick={() => { setShow(false) }}>Cancel</button>
            <button className='p-d-c' onClick={() => { deleteSellerProduct(selectedProductId) }}>Confirm</button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ProductCard;
